// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"0a4adf6c","374":"69fb763d"}[chunkId] + ".chunk.css";
};